import React, { useState } from "react";
import { Container, Divider } from "../GodMode";
import Button from "../../Generic/Button";
import Card from "../../Generic/Card";
import NumberListComponent from "../../Generic/NumberListSelect";
import Checkbox from "../../Generic/Checkbox";
import styled from "styled-components";

const CHEF_TASKS = {
	TURN_NO_MACHINE: "TURN_ON_MACHINE",
	TURN_OFF_MACHINE: "TURN_OFF_MACHINE",
	BOARDS_OTA: "OTA",
	READY_MACHINE : "READY_MACHINE"
};

const CHEF_TASKS_CONFIG = {
	[CHEF_TASKS.TURN_NO_MACHINE]: { 
		taskType: "turn_on_machine", 
		name: "Turn Machine ON" 
	},
	[CHEF_TASKS.TURN_OFF_MACHINE]: { 
		taskType: "turn_off_machine", 
		name: "Turn Machine OFF" 
	},
	[CHEF_TASKS.BOARDS_OTA]: { 
		taskType: "ota", 
		name: "OTA Update" 
	},
	[CHEF_TASKS.READY_MACHINE]: { 
		taskType: "ready_machine", 
		name: "Ready Machine" 
	},
};

const Div = styled.div`
	background: ${(props) => props.background};
	position: ${(props) => props.position};
	top: ${(props) => props.top};
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	z-index: ${(props) => props.zIndex};
	gap: ${(props) => props.gap};
`;

const Chef = ({ sendTask, loadingStates }) => {
	const [modulesToUpdate, setModulesToUpdate] = useState([]);
	const [checkForUpdates, setCheckForUpdates] = useState(true);

	const isTurnOnLoading = loadingStates[CHEF_TASKS_CONFIG[CHEF_TASKS.TURN_NO_MACHINE].taskType] || false;
	const isTurnOffLoading = loadingStates[CHEF_TASKS_CONFIG[CHEF_TASKS.TURN_OFF_MACHINE].taskType] || false;
	const isReadyLoading = loadingStates[CHEF_TASKS_CONFIG[CHEF_TASKS.READY_MACHINE].taskType] || false;
	const isOTALoading = loadingStates[CHEF_TASKS_CONFIG[CHEF_TASKS.BOARDS_OTA].taskType] || false;

	function prepareModulePayload(moduleList) {
		let newPayload = [];
		for(const moduleId of moduleList) {
			newPayload.push({ moduleId });
		}
		return newPayload;
	}

	function sendOTATask(modulesToUpdate, checkForUpdates) {
		const modulePayload = prepareModulePayload(modulesToUpdate);
		const successCallback = () => {
			setModulesToUpdate([]);
		};
		sendTask(CHEF_TASKS_CONFIG[CHEF_TASKS.BOARDS_OTA], { checkForUpdates, modulesToUpdate: modulePayload }, successCallback);
	}

	const handleTurnOnMachine = async () => {
		await sendTask(CHEF_TASKS_CONFIG[CHEF_TASKS.TURN_NO_MACHINE], {});
	};

	const handleTurnOffMachine = async () => {
		await sendTask(CHEF_TASKS_CONFIG[CHEF_TASKS.TURN_OFF_MACHINE], {});
	};

	const handleReadyMachine = async () => {
		await sendTask(CHEF_TASKS_CONFIG[CHEF_TASKS.READY_MACHINE], {});
	};

	return (
		<>
			<Container>
				<Button onClick={handleTurnOnMachine} disabled={isTurnOnLoading}>
					Turn Machine ON
				</Button>
				<Button onClick={handleTurnOffMachine} disabled={isTurnOffLoading}>
					Turn Machine OFF
				</Button>
				<Button onClick={handleReadyMachine} disabled={isReadyLoading}>
					Ready Machine
				</Button>
			</Container>
			<Divider />
			<Container>
				<Card gap="1rem" >
					<Div width="100%" gap="0.5rem" >
						<Checkbox defaultChecked={checkForUpdates} onClick={(e) => setCheckForUpdates(e.target.checked)} />
						Check For Updates
					</Div>
					<NumberListComponent placeholder={"Enter Module to Update"} numbers={modulesToUpdate} setNumbers={setModulesToUpdate} />
					<Div jContent="flex-end" width="100%" >
						<Button
							onClick={() => sendOTATask(modulesToUpdate, checkForUpdates)}
							disabled={isOTALoading}>
							OTA
						</Button>
					</Div>
				</Card>
			</Container>
		</>
	);
};

export default Chef;
